import React, { useMemo } from 'react';
import PlotlyComponent from 'react-plotly.js';

interface ILineSeriesProps {
  id?: string;
  data: Array<{ Time: Date; Value: number }>;
  name: string;
  color: string;
  variable: string;
  title?: string;
}

const Plot = PlotlyComponent as any;

const SingleLineSeries: React.FC<ILineSeriesProps> = ({
  id,
  data,
  name,
  color,
  variable,
  title,
}) => {
  const chartData = useMemo(
    () => [
      {
        x: data.map((d) => d.Time),
        y: data.map((d) => d.Value),
        type: 'scatter' as const,
        mode: 'lines' as const,
        name: name,
        line: { color: color },
      },
    ],
    [data, name, color]
  );

  const containerStyle = {
    width: '100%',
    height: '100%',
    position: 'relative' as const,
    display: 'flex',
    flexDirection: 'column' as const,
    alignItems: 'stretch',
    justifyContent: 'center',
    padding: '10px',
  };

  const plotStyle = {
    width: '100%',
    height: '100%',
  };

  return (
    <div id={id} style={containerStyle}>
      <Plot
        data={chartData}
        layout={{
          title: '',
          xaxis: { title: 'Time' },
          yaxis: { title: variable },
          autosize: true,
          margin: { l: 50, r: 50, t: 50, b: 50 },
        }}
        config={{
          displaylogo: false,
          toImageButtonOptions: {
            filename: `Timeseries_${name}_${
              new Date().toISOString().split('T')[0]
            }`,
          },
          displayModeBar: true,
          responsive: true,
        }}
        useResizeHandler={true}
        style={plotStyle}
      />
    </div>
  );
};

export default React.memo(SingleLineSeries);
